import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EndpointConstants } from '../endpoints-configurations/endpoint-constants';
import { HttpClient } from '@angular/common/http';

export type AppSettingsType = {
  [key: string]: any;
  onlineApiBase: string;
  b2C_tenantName: string;
  b2C_clientId: string;
  b2C_signout: string;
  b2C_signInPolicy: string;
  b2C_signUpPolicy: string;
  b2C_SSO_invite: string;
  apimSubscriptionKey: string;
  urlWebSocketRemoteSupport: string;
  remoteSupportSubscriptionKey: string;
};

@Injectable({
  providedIn: 'root',
})
export class AppSettingsLoaderService {
  private readonly defaultValue: AppSettingsType = {
    onlineApiBase: environment.urlApimOnline,
    b2C_tenantName: environment.B2C_tenantName,
    b2C_clientId: environment.B2C_clientId,
    b2C_signout: environment.B2C_signout,
    b2C_SSO_invite: environment.B2C_SSO_invite,
    b2C_signInPolicy: environment.B2C_signInPolicy,
    b2C_signUpPolicy: environment.B2C_signUpPolicy,
    apimSubscriptionKey: environment.apimSubscriptionKey,
    urlWebSocketRemoteSupport: environment.urlWebSocketRemoteSupport,
    remoteSupportSubscriptionKey: environment.remoteSupportSubscriptionKey,
  };
  private appSettings = this.defaultValue;

  private currentConfig = new BehaviorSubject<AppSettingsType>(null);
  public currentConfig$ = this.currentConfig.asObservable().pipe(
    filter((config) => !!config),
    shareReplay({ refCount: true }),
  );

  constructor(private readonly http: HttpClient) {}

  initConfig() {
    const url = EndpointConstants.ApiEdgeSettings;

    this.http.get<AppSettingsType>(url).subscribe({
      next: (config) => {
        this.currentConfig.next(config);
      },
      error: () => {
        this.currentConfig.next(this.defaultValue);
      },
    });
  }

  setConfig(config: AppSettingsType): void {
    this.appSettings = config;
  }

  getConfig(): AppSettingsType {
    return this.appSettings;
  }

  getDefaultValue(): AppSettingsType {
    return this.defaultValue;
  }
}
